module.exports = __webpack_public_path__ + "img/feature_buy_en.1e39ba98.png";